export const SYMBOL_VALIDATION = /[$-/:-?{-~!"^_`\[\]]/;
